import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function Process() {
  return (
    <section id="process" data-testid="process" className="relative py-12 md:py-16 border-y border-line">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>How we work</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            A proven path from idea to <span className="text-gradient">production</span>
          </h2>
        </Reveal>

        <div className="mt-12 relative">
          <div className="absolute left-0 right-0 top-6 h-px bg-line hidden lg:block" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-8 lg:gap-4">
            {PROCESS.map((p, i) => (
              <Reveal key={p.step} delay={i * 0.05}>
                <div className="relative">
                  <div className="relative z-10 grid place-items-center h-12 w-12 rounded-full glass border border-brand/40 font-mono text-sm text-brand">
                    {p.step}
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-semibold">{p.title}</h3>
                  <p className="mt-2 text-sm text-textsub leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
